<div
  class="content"
  [class.split-view]="viewMode === 'SPLIT'"
>
  @if (viewMode === 'TEXT_ONLY' || viewMode === 'SPLIT') {
    <div class="editor-section">
      <div class="formatting-toolbar">
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyHeading(1)"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.HEADING_1 | translate"
          aria-label="Heading 1"
        >
          <span class="heading-label">H1</span>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyHeading(2)"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.HEADING_2 | translate"
          aria-label="Heading 2"
        >
          <span class="heading-label">H2</span>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyHeading(3)"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.HEADING_3 | translate"
          aria-label="Heading 3"
        >
          <span class="heading-label">H3</span>
        </button>

        <span class="toolbar-divider"></span>

        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyBold()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.BOLD | translate) +
            shortcutLabels['bold'].tooltip
          "
          aria-label="Bold"
        >
          <mat-icon>format_bold</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyItalic()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.ITALIC | translate) +
            shortcutLabels['italic'].tooltip
          "
          aria-label="Italic"
        >
          <mat-icon>format_italic</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyStrikethrough()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.STRIKETHROUGH | translate) +
            shortcutLabels['strikethrough'].tooltip
          "
          aria-label="Strikethrough"
        >
          <mat-icon>strikethrough_s</mat-icon>
        </button>

        <span class="toolbar-divider"></span>

        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyBulletList()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.BULLET_LIST | translate) +
            shortcutLabels['bullet'].tooltip
          "
          aria-label="Bulleted list"
        >
          <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyNumberedList()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.NUMBERED_LIST | translate) +
            shortcutLabels['numbered'].tooltip
          "
          aria-label="Numbered list"
        >
          <mat-icon>format_list_numbered</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyTaskList()"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.TASK_LIST | translate"
          aria-label="Task list"
        >
          <mat-icon>checklist</mat-icon>
        </button>

        <span class="toolbar-divider"></span>

        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyQuote()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.QUOTE | translate) +
            shortcutLabels['quote'].tooltip
          "
          aria-label="Quote"
        >
          <mat-icon>format_quote</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyInlineCode()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.INLINE_CODE | translate) +
            shortcutLabels['code'].tooltip
          "
          aria-label="Inline code"
        >
          <mat-icon>code</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onApplyCodeBlock()"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.CODE_BLOCK | translate"
          aria-label="Code block"
        >
          <mat-icon>integration_instructions</mat-icon>
        </button>

        <span class="toolbar-divider"></span>

        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onInsertLink()"
          [matTooltip]="
            (T.F.NOTE.D_FULLSCREEN.TOOLBAR.INSERT_LINK | translate) +
            shortcutLabels['link'].tooltip
          "
          aria-label="Insert link"
        >
          <mat-icon>link</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onInsertImage()"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.INSERT_IMAGE | translate"
          aria-label="Insert image"
        >
          <mat-icon>image</mat-icon>
        </button>
        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="onInsertTable()"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.INSERT_TABLE | translate"
          aria-label="Insert table"
        >
          <mat-icon>table_chart</mat-icon>
        </button>

        <span class="toolbar-divider"></span>

        <button
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="openShortcutsHelp()"
          [matTooltip]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.KEYBOARD_SHORTCUTS | translate"
          [aria-label]="T.F.NOTE.D_FULLSCREEN.TOOLBAR.KEYBOARD_SHORTCUTS | translate"
        >
          <mat-icon>keyboard</mat-icon>
        </button>
      </div>

      <textarea
        #textareaEl
        [(ngModel)]="data.content"
        (keydown)="keydownHandler($event)"
        (paste)="pasteHandler($event)"
        (ngModelChange)="ngModelChange($event)"
        rows="1"
        tabindex="3"
      ></textarea>
    </div>
  }
  @if (viewMode === 'PARSED' || viewMode === 'SPLIT') {
    <markdown
      #previewEl
      (click)="clickPreview($event)"
      [data]="resolvedContentData"
      class="markdown-preview markdown"
    ></markdown>
  }
</div>

<div class="controls">
  <div class="left-buttons">
    <mat-button-toggle-group
      [(ngModel)]="viewMode"
      (change)="onViewModeChange()"
    >
      <mat-button-toggle
        value="TEXT_ONLY"
        [matTooltip]="T.F.NOTE.D_FULLSCREEN.VIEW_TEXT_ONLY | translate"
        ><mat-icon>notes</mat-icon></mat-button-toggle
      >
      <mat-button-toggle
        value="SPLIT"
        class="hide-xs"
        [matTooltip]="T.F.NOTE.D_FULLSCREEN.VIEW_SPLIT | translate"
        ><mat-icon>vertical_split</mat-icon></mat-button-toggle
      >
      <mat-button-toggle
        value="PARSED"
        [matTooltip]="T.F.NOTE.D_FULLSCREEN.VIEW_PARSED | translate"
        ><mat-icon>photo</mat-icon></mat-button-toggle
      >
    </mat-button-toggle-group>
  </div>

  <button
    id="T-close-note"
    (click)="close(true)"
    mat-button
  >
    <mat-icon>close</mat-icon>
    {{ T.G.CLOSE | translate }}
  </button>

  <button
    id="T-save-note"
    (click)="close()"
    color="primary"
    mat-stroked-button
  >
    <mat-icon>save</mat-icon>
    {{ T.G.SAVE | translate }}
  </button>
</div>
